import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { loginUser } from "../../../redux/actions/user.actions";
import RootState from "../../../redux/states/root.state";
import { AppDispatch } from "../../../redux/store";
import AuthAlert from "./AuthAlert";
import PasswordInput from "./PasswordInput";

const LoginForm: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const loginError = useSelector((state: RootState) => state.user.error);
  const loading = useSelector((state: RootState) => state.user.loading);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await dispatch(loginUser({ Email: email, Password: password }));
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <form className="auth-form" onSubmit={handleLogin} noValidate>
      <div className="field">
        <label className="field-label" htmlFor="email">Email or username</label>
        <input
          id="email"
          name="email"
          className="input"
          type="text"
          autoComplete="username"
          autoFocus
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="field">
        <label className="field-label" htmlFor="password">Password</label>
        <PasswordInput
          id="password"
          name="password"
          value={password}
          onChange={setPassword}
          autoComplete="current-password"
          required
        />
      </div>

      <div className="auth-meta">
        <label className="auth-check" htmlFor="remember">
          <input
            id="remember"
            name="remember"
            type="checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          Remember me
        </label>
        <Link to="/forgot-password" className="auth-link">Forgot password?</Link>
      </div>

      {loginError && <AuthAlert kind="error" message={loginError} />}

      <div className="auth-actions">
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? <span className="spinner auth-btn-spinner" aria-label="Signing in" /> : "Log in"}
        </button>
      </div>

      <p className="auth-footer">
        Don't have an account?
        <Link to="/register" className="auth-link">Sign up</Link>
      </p>
    </form>
  );
};

export default LoginForm;
